<template>
  <div class="container page" style="background-color: #1f1c1f">
    <van-nav-bar :title="$t('setting.modify_real_name')" class="nav-bar">
      <template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back()"
          style="width: 20px; height: 15px"
        />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <van-field
        v-model="name"
        :label="$t('setting.name')"
        :placeholder="$t('setting.name_place')"
      />
    </van-cell-group>
    <p style="color: #f3c7a2; padding: 0 16px">{{ $t("setting.name_tip") }}</p>

    <div class="sub-btn" @click="save()">제출하다</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      userInfo: {},
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    save() {
      if (this.userInfo.name) {
        this.$toast(this.$t("setting.repect"));
        return true;
      }
      if (this.name === "" || this.name === null || this.name === undefined) {
        this.$toast.fail(this.$t("setting.name_place"));
        return false;
      }
      this.$http({
        method: "get",
        data: { name: this.name },
        url: "user_set_name",
      }).then((res) => {
        if (res.code === 200) {
          this.getUserInfo();
          this.name = this.userInfo.name;
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.sub-btn {
  background: linear-gradient(#fde3ca, #e7b486);

  display: inline-block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 2rem;
  margin: 60px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
}
/deep/ .van-field__label {
  color: #ccc;
}
.van-cell-group {
  background-color: transparent;
  padding: 30px 0;
  &:after {
    display: none;
  }
}
.van-cell {
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  /deep/ .van-field__control {
    color: #f3c7a2;
  }
  &:after {
    display: none;
  }
}

.container p {
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}

@media screen and (min-width: 1024px) {
  .container {
    width: 430px;
    margin: 0 auto;
    height: 100vh;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8),
      0 0 0 1px rgba(255, 255, 255, 0.05);
  }
  .nav-bar {
    height: 50px;
  }

  .van-cell-group {
    padding: 15px 0;
  }
  .van-cell {
    width: 90%;
    height: 50px;
    padding: 10px;
    margin: 0 auto;
    font-size: 16px;
    border-radius: 10px;
    display: flex;
    align-items: center;
  }
  .container p {
    font-size: 16px;
    margin-top: 10px;
  }

  .sub-btn {
    font-size: 16px;
    margin: 10px auto;
    padding: 10px 70px;
  }
}
</style>
